import { render, staticRenderFns } from "./NewsForUserItem.vue?vue&type=template&id=2d58ec26"
import script from "./NewsForUserItem.vue?vue&type=script&lang=js"
export * from "./NewsForUserItem.vue?vue&type=script&lang=js"
import style0 from "./NewsForUserItem.vue?vue&type=style&index=0&id=2d58ec26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports